import React, { FC, useState } from "react";
import { Button, Table, Upload, message, Modal, Input } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { useEnquiryDetailModel } from "../enquiryDetailModel";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { formatInt, getRandomStr } from "@/utils/utils";
import { IEnquiryMaterialDetail } from "../../../enquiryTypes";
import { useGlobalModel } from "@/model/globalModel";
import { importPropsConfig1 } from "@/utils/importFile1";
import { enquiryService } from "../../../enquiryService";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        addList,
        editList,
        updateList,
        removeMaterial,
        setMaterialDialog,
        exportEnquiry,
        downloadTpl,
        addFormVal,
        editFormVal
    } = useEnquiryDetailModel(({ addList, editList }) => [addList, editList]);
    const { user: { shopCode }, setLoadingInfo } = useGlobalModel(({ user }) => [user])

    const tableList = mode === "edit" ? editList : addList;
    const formVal = mode === "edit" ? editFormVal : addFormVal;
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

    const column = [
        {
            title: '序号',
            width: 40,
            align: "center",
            fixed: "left",
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '商品编码',
            width: 160,
            dataIndex: 'materialCode',
        }, {
            title: '商品名称',
            width: 160,
            dataIndex: 'materialName',
        }, {
            title: '商品名称-英文',
            width: 160,
            dataIndex: 'materialEname',
        }, {
            title: '商品类型',
            width: 160,
            dataIndex: 'typeName',
        }, {
            title: '询价数量',
            width: 160,
            dataIndex: 'num',
            // editable: true
            editable: formVal.status !=='gtm.inquiry.pend'
        }, {
            title: '规格',
            width: 160,
            dataIndex: 'model',
        }, {
            title: '单位',
            width: 160,
            dataIndex: 'unitName',
        }, {
            title: '海关编码',
            width: 100,
            dataIndex: 'customsCode',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            editable: true
        },
    ];

    const newColumn = column.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: any, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                editable: col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: any) => {
        row.num = +formatInt(row.num);
        let dataSource = [...tableList];
        const index = dataSource.findIndex((item) => row.key === item.key);
        const item = dataSource[index];
        dataSource.splice(index, 1, { ...item, ...row });
        updateList(mode, dataSource);
    }

    //导入明细成功
    const upLoadCallback = (list: IEnquiryMaterialDetail[]) => {
        setLoadingInfo({ loadingVisible: false, txt: "" });
        if (list && list.length) {
            let dataSource = [...tableList];
            let strArr: string[] = []
            // createUser: ""
            // id: ""
            // materialCode: "materialCode1"
            // materialEname: "xiao1"
            // materialName: "小庞测试1"
            // num: 22
            // shopCode: "SHOP-M-00000102"
            // typeCode: "material-type.high-speed-C"
            // typeName: "高速机C类"
            // updateUser: ""
            list.forEach(material => {
                //选中的是否存在列表
                let isExist = dataSource.find(item => item.materialCode === material.materialCode);
                if (!isExist) {
                    let { id, ...item } = material;
                    dataSource.push({
                        ...item,
                        "key": getRandomStr(),  //自己用
                        "materialId": id, // "物料id",
                        "note": "", // "备注"
                    })
                } else {
                    strArr.push(material.materialName ?? "")
                }
            });
            strArr.length && message.warning(`【${strArr.join()}】重复的配件已做过滤`)
            updateList(mode, dataSource);
        }
    };

    const action = <>
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_ADD_M}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => setMaterialDialog(true)}
            disabled={formVal.status ==='gtm.inquiry.pend'}
        >新增</Button>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_DEL_M}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (!selectedRowKeys.length) {
                    message.warning("请选择你要删除的商品");
                    return;
                }
                removeMaterial(mode, selectedRowKeys)
            }}
            disabled={formVal.status ==='gtm.inquiry.pend'}
        >删除</Button>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_DLOAD}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { downloadTpl() }}
        >下载模板</Button>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_IM}> */}
        <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig1(`/gtm/inquiry/detail/import/${shopCode}`, upLoadCallback)}>
            <Button className="mr-5" type="link" shape="round">导入</Button>
        </Upload>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_EX}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { exportEnquiry() }}
        >导出</Button>

        {/* </YhAuth> */}
    </>

    const leftChildren = mode === 'edit' ? <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据进行排序");
                    return;
                }
                let number = "";
                Modal.confirm({
                    title: "请输入排序数字",
                    content: <>
                        <Input placeholder="请输入排序数字" onChange={(e) => { number = e.target.value }} />
                    </>,
                    okText: '确定',
                    cancelText: '取消',
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            if (number && /^[+-]?\d*\.?\d*$/.test(number)) {
                                resolve(number);
                            } else {
                                message.warning("请输入排序数字");
                                reject('请输入排序数字');
                            }
                        }).then(async (res: any) => {
                            let { retData } = await enquiryService.inquiryOrderNum({
                                id: selectedRowKeys[0],
                                orderNum: +res
                            })
                            message.success("修改成功")
                        });
                    },
                    onCancel: () => { }
                })
            }}
        >修改顺位</Button>
    </> : <></>
    return (
        <YhBox title={leftChildren} style={{ marginBottom: "75px" }} rightChildren={action}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={{
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: IEnquiryMaterialDetail[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[]);
                    }
                }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newColumn as ColumnsType<any>}
                dataSource={tableList}
                pagination={false}
                scroll={{ x: 'max-content', y: 400 }}
            />
        </YhBox>
    )
}

